/* global Swiper */
const teaserSliderElements = document.querySelectorAll('[data-slider="teaser__slider"]');

Array.prototype.forEach.call(teaserSliderElements, (el) => {
  const teaserSliderOptions = {
    slidesPerView: 'auto',
    spaceBetween: 12,
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  };

  // eslint-disable-next-line no-unused-vars
  const teaserSlider = new Swiper(el, teaserSliderOptions);
});
